<div class="container h-100">
  <div class="row h-100 justify-content-center align-items-center">
    <div class="card SmallForm rounded">
      <div class="card-header MyCardHeader rounded-top">
        <h2 class="Head">{{ 'NOTIFICATION' | translate }}</h2>
      </div>
      <div class="card-body MyCardBody rounded-bottom text-center">
        <p>{{ 'THIS_PAGE_WAS_NOT_FOUND' | translate }}</p>
      </div>
      <div class="form-group col-12 mt-3">
        <button
          class="btn btn-block btn-secondary"
          type="button"
          (click)="goHome()"
        >
          <span> {{ 'CLOSE' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
